import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "HelpCenterCategoryWidget" */ './HelpCenterCategoryWidget'),
  modules: ['./HelpCenterCategoryWidget'],
  loading: () => <div />
});

export default LoadableWidget;
